/**
 * Takes ratio values in [0,1] and returns a CSS percentage value.
 */
export function cssPercentage(val: unknown) {
  if (Number.isFinite(val))
    return (val as number) * 100 + '%';
  else if (typeof val === 'string' && val)
    return val;
  return undefined;
}

export function cssPixel(val: unknown) {
  if (Number.isFinite(val))
    return (val as number) + 'px';
  if (typeof val === 'string' && val)
    return val;
  return undefined;
}